/** Etiquetas especiales guardadas en `cuerpo.musicGenres`. */
export const COMUNIDAD_GENERO_MULTICULTURAL = 'Multicultural (sin género definido)';
export const COMUNIDAD_GENERO_DESCONOCIDO = 'Género desconocido';

export const COMUNIDAD_MAX_MUSIC_GENRES = 8;

const SPECIAL = new Set([COMUNIDAD_GENERO_MULTICULTURAL, COMUNIDAD_GENERO_DESCONOCIDO]);

/** @param {unknown} c — `cuerpo` jsonb */
export function musicGenresFromCuerpo(c) {
  const raw = c && typeof c === 'object' ? c.musicGenres : null;
  if (!Array.isArray(raw)) return [];
  return raw.map(g => String(g ?? '').trim()).filter(Boolean).slice(0, COMUNIDAD_MAX_MUSIC_GENRES);
}

/** @param {string[]} genres */
export function musicGenreModeFromGenres(genres) {
  const list = Array.isArray(genres) ? genres : [];
  if (list.includes(COMUNIDAD_GENERO_MULTICULTURAL)) return 'multicultural';
  if (list.includes(COMUNIDAD_GENERO_DESCONOCIDO)) return 'desconocido';
  return 'specific';
}

/**
 * @param {{ musicGenreMode?: string, musicGenres?: string[] }} form
 * @returns {string[]}
 */
export function normalizeComunidadMusicGenresForSave(form) {
  const mode = form?.musicGenreMode || 'specific';
  if (mode === 'multicultural') return [COMUNIDAD_GENERO_MULTICULTURAL];
  if (mode === 'desconocido') return [COMUNIDAD_GENERO_DESCONOCIDO];
  const list = Array.isArray(form?.musicGenres) ? form.musicGenres : [];
  return [...new Set(list.map(s => String(s).trim()).filter(g => g && !SPECIAL.has(g)))].slice(
    0,
    COMUNIDAD_MAX_MUSIC_GENRES
  );
}

/** @param {{ musicGenreMode?: string, musicGenres?: string[] }} form */
export function validateComunidadMusicGenres(form) {
  const mode = form?.musicGenreMode || 'specific';
  if (mode === 'multicultural' || mode === 'desconocido') return { ok: true };
  const n = normalizeComunidadMusicGenresForSave({ ...form, musicGenreMode: 'specific' }).length;
  if (n < 1) {
    return {
      ok: false,
      message: 'Elige al menos un género musical, o marca «Multicultural» / «Género desconocido».',
    };
  }
  return { ok: true };
}

/** @param {string[]|null|undefined} genres */
export function comunidadMusicGenresSearchText(genres) {
  return (Array.isArray(genres) ? genres : []).join(' ').toLowerCase();
}

/** @param {string[]|null|undefined} genres */
export function comunidadMusicGenresDisplayLabels(genres) {
  const list = Array.isArray(genres) ? genres : [];
  if (!list.length) return [];
  return list;
}
